import { SearchResponseEntry } from '../../../types/global'; // eslint-disable-line import/extensions

export const getClosingHourFromBank = ({
  openingTime,
}: SearchResponseEntry) => {
  const today = new Date().getDay();
  const openingArray = [
    openingTime.sun,
    openingTime.mon,
    openingTime.tue,
    openingTime.wed,
    openingTime.thu,
    openingTime.fri,
    openingTime.sat,
  ];

  if (!openingArray[today]?.length) {
    return undefined;
  }

  return openingArray[today][1]
    ? openingArray[today][1][1]
    : openingArray[today][0][1];
};
